/**
 * @license
 * Copyright 2024 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
import { noStreams, ok, readFromStart } from "./utils.js";
export { PersistentFile };
class PersistentFile {
    graphUrl;
    path;
    backend;
    constructor(graphUrl, path, backend) {
        this.graphUrl = graphUrl;
        this.path = path;
        this.backend = backend;
    }
    async read(inflate, start = 0) {
        const reading = await this.backend.read(this.graphUrl, this.path, inflate);
        if (!ok(reading)) {
            return reading;
        }
        return readFromStart(this.path, reading, start);
    }
    async append(data, done, receipt) {
        const checkForStreams = noStreams(done, receipt);
        if (!ok(checkForStreams)) {
            return checkForStreams;
        }
        return this.backend.append(this.graphUrl, this.path, data);
    }
    copy() {
        throw new Error("Method not implemented.");
    }
    queryEntry(_path) {
        throw new Error("Method not implemented.");
    }
    delete() {
        throw new Error("Method not implemented.");
    }
    data = [];
}
//# sourceMappingURL=persistent-file.js.map